import React, { Component } from "react";
import { get } from "lodash";
import { connect } from "react-redux";

import { CheckBoxMemo } from "./CheckBox";
import { getValueByFilter } from "../../../helpers/boda-boda/common-helpers/common.helpers";
import { changeInputFn } from "../../../store/boda-boda/form/actions";
import { formCacheLevel } from "../../../config/boda-boda/template.config";


const emptyFun = (...para) => undefined;

class CheckBoxWithState extends Component {

    static defaultProps = {
        elementWrapperStyle: "",
        elementStyle: "",
        labelText: "",
        inputName: "",
        inputValue: "",
        isDisabled: false,
        helperText: "",
        inputStatePath: "",
        formGroupName: "",
        cacheLevel: formCacheLevel.updateOnFormGroupChange,
        onChangeFn: emptyFun,
    }

    constructor(props) {
      super(props);
    }

    render() {
        let {
            elementWrapperStyle, elementStyle, labelText,
            inputName, inputValue, isDisabled,
            helperText, inputStatePath, formGroupName,
            cacheLevel, changeInputFn, formState
        } = this.props;

        return (
            <CheckBoxMemo
                elementWrapperStyle={elementWrapperStyle}
                elementStyle={elementStyle}
                labelText={labelText}
                inputName={inputName}
                inputValue={get(formState,inputStatePath?inputStatePath:`${formGroupName}.${inputName}`,inputValue)}
                inputError={getValueByFilter(get(formState,`${formGroupName}._errors`,[]),["property",((inputStatePath)?inputStatePath.substr(formGroupName.length + 1):inputName)],"error","","")}
                isDisabled={isDisabled}
                helperText={helperText}
                updateStatus={get(formState,`${formGroupName}._updateStatus`,undefined)}
                cacheLevel={cacheLevel}
                onChangeFn={(eventData)=>changeInputFn(formGroupName,inputName,inputStatePath,eventData.value)}
            />
        )
    }
}

const mapStateToProps = state => {
    return {
        formState: state.FormData
    };
};

export default connect(mapStateToProps, { changeInputFn })(CheckBoxWithState);
